import { API_URL } from 'src/app/shared/enums/api-enums';
import { Injectable } from '@angular/core';
import { GetAllResponse, RESTfulApi } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';
import { ApplicationTrainingDocument } from '../model/application-training-document.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ApplicationTrainingDocumentDetailService {
  constructor(
    private http: HttpClient,
    private utilities: UtilitiesService) { }

  postApplicationTrainingDocument(body, type): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + type;
    return this.utilities.req.httpPost<GetAllResponse<ApplicationTrainingDocument>>(url, body);
  }

  getApplicationTrainingDocumentByID(id, type): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + type + `/${id}`;
    return this.utilities.req.httpGet<GetAllResponse<ApplicationTrainingDocument>>(url);
  }

  getApplicationTrainingDocument(type): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + type;
    return this.utilities.req.httpGet<GetAllResponse<ApplicationTrainingDocument>>(url);
  }

  getApplicationTrainingDocumentPublish(): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + API_URL.APPLICATION_TRAINING_URL + `/publish`;
    return this.utilities.req.httpGet<GetAllResponse<ApplicationTrainingDocument>>(url);
  }

  deleteApplicationTrainingDocument(sso, type): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + type + `/${sso}`;
    return this.utilities.req.httpDelete<GetAllResponse<ApplicationTrainingDocument>>(url);
  }

  editApplicationTrainingDocument(id, body, type): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + type;
    return this.utilities.req.httpPut<GetAllResponse<ApplicationTrainingDocument>>(url, body);
  }

}
